import styled from '@emotion/styled/macro';
import React from 'react';
import { UnderlineTabs } from '../../base/underline-tabs';
import type { StatementTabId } from '../statement-details.types';

export type StatementTabItem = {
    id: StatementTabId;
    label: string;
    count?: number;
};

export type StatementTabsBarProps = {
    tabs: StatementTabItem[];
    activeTab: StatementTabId;
    onTabChange: (tab: StatementTabId) => void;
};

const Bar = styled(UnderlineTabs)`
    margin-bottom: 20px;
` as typeof UnderlineTabs;

export const StatementTabsBar: React.FC<StatementTabsBarProps> = ({ tabs, activeTab, onTabChange }) => (
    <Bar tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
);
